export default "__VITE_ASSET__BkKjgWZ2__"